<template>
  <div class="message-redpack" @click="handleClick">
    <div class="rp-card">
      <div class="rp-left">
        <span class="rp-icon iconfont icon-red-packet-fill"></span>
      </div>
      <div class="rp-right">
        <div class="rp-title">{{ msgInfo.content }}</div>
        <div class="rp-sub">请在手机端查看红包</div>
      </div>
      <span class="rp-arrow">›</span>
    </div>
    <div class="rp-brand">红包</div>
  </div>
</template>

<script>
export default {
  name: "RedPackCard",
  props: {
    msgInfo: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    handleClick() {
      this.$emit("click", this.msgInfo);
    }
  }
};
</script>

<style scoped lang="scss">
/* 新增：红包卡片样式 */
.message-redpack {
  //   width: 250px;
  //   height: 100px;
  max-width: 280px;
  min-width: 280px;
  padding: 0;

  /* 按压态反馈 */
  &:active {
    .rp-card {
      transform: scale(0.995);
      filter: brightness(0.97);
    }
  }

  /* 卡片主体：渐变背景 + 圆角 + 阴影 */
  .rp-card {
    display: flex;
    align-items: center;
    padding: 11px 12px;
    border-radius: 16px 16px 0 0;
    background: linear-gradient(135deg, #fa5a4b 0%, #f34739 100%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
    transition: transform 0.08s ease, filter 0.08s ease;
  }

  /* 左侧圆形图标容器 */
  .rp-left {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: rgba(255, 240, 225, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }

  /* 红包图标（使用现有 iconfont） */
  .rp-icon {
    font-size: 40px;
    color: #ffd36e;
  }

  /* 右侧文字区 */
  .rp-right {
    flex: 1;
    min-width: 0;

    /* 标题（红包名称） */
    .rp-title {
      font-size: 18px;
      line-height: 40px;
      color: #ffffff;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* 副文 */
    .rp-sub {
      margin-top: 4px;
      font-size: 15px;
      line-height: 32px;
      color: #ffe1d2;
      letter-spacing: 0.5px;
    }
  }

  /* 右侧箭头（更轻） */
  .rp-arrow {
    margin-left: 14px;
    font-size: 42px;
    line-height: 1;
    color: rgba(255, 255, 255, 0.8);
  }

  /* 底部品牌条（与卡片同宽） */
  .rp-brand {
    padding: 7px 12px;
    border-radius: 0 0 16px 16px;
    background: white;
    font-size: 14px;
    border-top: 1rpx solid rgba(255, 255, 255, 0.3); /* 轻分隔线，接近微信效果 */
    color: #9aa1aa;
    /* 右侧气泡（自己发送）时的底部品牌条可略暗 */
    .message-right & {
      background: #eef0f3;
    }
  }
}
</style>
